import Autocomplete from './Autocomplete';
import Badge from './Badge';
import Button from './Button';
import CardContent from './CardContent';
// import Checkbox from './Checkbox';
import Chip from './Chip';
import IconButton from './IconButton';
import InputLabel from './InputLabel';
import LinearProgress from './LinearProgress';
import Link from './Link';
import ListItemIcon from './ListItemIcon';
import OutlinedInput from './OutlinedInput';
import Tab from './Tab';
import TableCell from './TableCell';
import Tabs from './Tabs';
import Typography from './Typography';
import TableContainer from './TableContainer';
import Paper from './Paper';
import ToggleButton from './ToggleButton';

export default function ComponentsOverrides(theme) {
    return {
        ...Autocomplete(),
        ...Paper(theme),
        ...Button(theme),
        ...Badge(theme),
        ...CardContent(),
        // ...Checkbox(theme),
        ...Chip(theme),
        ...IconButton(),
        ...InputLabel(theme),
        ...LinearProgress(),
        ...Link(),
        ...ListItemIcon(),
        ...OutlinedInput(theme),
        ...Tab(theme),
        ...TableCell(theme),
        ...Tabs(),
        ...Typography(),
        ...TableContainer(theme),
        ...ToggleButton(theme)
    };
}
